<template>
  <div>
    <b-card>
      <b-row>
        <b-col>
          <div class="position-relative">
            <form-builder
              ref="formbuilder"
              v-model="formData"
              :on-submit="onSubmit"
              grid-class="px-1 row"
              :form-structure="formStructure"
              @waybillPaste="handleWaybillPaste"
              @searchWaybill="getOrderDetails"
              @waybillScan="getOrderDetails"
            >
              <template slot="buttons">
                <b-row>
                  <b-col
                    cols="12"
                    md="9"
                    class="ml-1"
                  >
                    <b-form-group
                      label-for="proof_images"
                      description="Up to 4 images per status, ≤ 5 MB each (jpeg/png/webp)."
                    >
                      <template #label>
                        <div class="d-flex justify-content-between align-items-center w-100">
                          <span>Proof Images</span>
                          <small class="text-muted">({{ uploadedImages.length }}/{{ max_images }})</small>
                        </div>
                      </template>
                      <b-form-file
                        ref="proof_images"
                        multiple
                        :disabled="uploadedImages.length >= max_images"
                        accept="image/jpeg,image/png,image/webp"
                        browse-text="Choose File"
                        :placeholder="uploadedImages.length ? `${uploadedImages.length} file${uploadedImages.length === 1 ? '' : 's'} selected` : 'No file chosen'"
                        class="w-100"
                        @change="onSelectFiles"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    v-if="uploadedImages.length"
                    cols="12"
                    md="12"
                  >
                    <div class="uploader-grid">
                      <div
                        v-for="(img, idx) in uploadedImages"
                        :key="img.localId"
                        class="uploader-card"
                      >
                        <img
                          :src="img.preview"
                          alt=""
                          class="uploader-img"
                        >
                        <button
                          type="button"
                          class="uploader-remove"
                          aria-label="Remove"
                          @click.stop="removeImage(idx)"
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    class="d-flex d-md-block justify-content-end align-items-end"
                  >
                    <b-button
                      type="submit"
                      class="vh-5 mt-2 ml-1 ml-md-1 custom-button-color"
                      :disabled="isSubmitDisabled"
                    >
                      {{ loadingResponse ? 'Submitting...' : 'Submit' }}
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </form-builder>
            <b-input-label-info
              v-if="(formData.waybill_number?formData.waybill_number.length : 0) != settingWaybillLength"
              :left="120"
            />
            <!-- <b-tooltip
              target="weight-submit-info-icon"
              triggers="hover"
              variant="primary"
            >
              {{ weightRange }}
            </b-tooltip>
            <feather-icon
              id="weight-submit-info-icon"
              icon="InfoIcon"
              size="12"
              style="position:absolute; top:3; left:480;"
              class="text-primary"
            /> -->
          </div>
        </b-col>
      </b-row>
    </b-card>
    <FilterCard :applied-filter-count="appliedFilterCount">
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Picked Up Date"
            label-for="basicInput"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['status_date']"
                :opens="'right'"
                @update="updateDateRange('status_date', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </FilterCard>
    <b-card no-body>
      <div class="m-2">
        <b-row cols="12">
          <b-col
            md="12"
            lg="4"
            class="d-block d-sm-flex flex-wrap justify-content-start align-items-center mb-1 mb-md-0"
          >
            <bulk-submit
              :status-key="status_key"
              :selected-waybills="selectedWaybillArray"
              @bulkSubmit="onClickBulkAction"
            />
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-center mb-1 mb-md-0"
          >
            <b-button
              type="submit"
              class="custom-button-color-blur"
              :disabled="false"
            >
              Scanned Orders : {{ submitCount }}
            </b-button>
          </b-col>
          <b-col
            class="d-flex justify-content-end align-items-center mb-1 mb-md-0"
          >
            <ReportTableButtons
              :items="rows"
              :json_fieldz="json_fields"
              :name="`DeliveredByPickupRider - Page ${page}.xls`"
              :bulkname="`DeliveredByPickupRider.xls`"
              :fetch="getOrderListNoPagination"
              @refresh="onClickRefresh"
            />
          </b-col>
        </b-row>
        <b-row>
          <div class="font-weight-bolder text-muted ml-1 mt-1">
            {{ `${selectedWaybillArray.length} record${selectedWaybillArray.length === 1 ? '':'s'}` }} selected
          </div>
        </b-row>
      </div>

      <b-row>
        <b-col>
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :items="rows"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              show-empty
              sticky-header="100vh"
              class="hide-vertical-scroll"
              @sort-changed="sortChanged"
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #head()="{ field }">
                <div
                  class="sortable-header"
                >
                  <span class="header-text">{{ field.label }}</span>
                  <feather-icon
                    v-if="field.sortable"
                    :icon="sort === field.key
                      ? 'ArrowUpIcon'
                      : 'ArrowDownIcon'"
                    size="14"
                  />
                </div>
              </template>
              <template #head(id)>
                <div class="d-flex align-items-start">
                  <div>
                    <b-form-checkbox
                      id="selectAllCheckbox"
                      v-model="selectAllCheckbox"
                      name="selectAllCheckbox"
                      @change="onClickSelectAllCheckbox()"
                    />
                  </div>
                </div>
              </template>
              <template #cell(id)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="font-weight-bolder">
                      <b-form-checkbox
                        v-model="selectedWaybillArray"
                        :value="data.item.waybill_number"
                      />
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(waybill_number)="data">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :text="avatarText(data.item.customer_name)"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div
                      :class="{'font-weight-bolder ml-1 text-danger': data.item.temporary_warehouse_id !=null ,'font-weight-bolder ml-1 text-primary':data.item.temporary_warehouse_id ===null}"
                      @click="onClickViewOrderModal(data.item.id)"
                    >
                      {{ data.value }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ __dateTimeFormatter(data.item.created_at) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(merchant.name)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="">
                      {{ __orderMerchantName(data.item) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(customer_email)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      {{ data.item.customer_name }}
                    </div>
                    <div class="font-small-2">
                      {{ data.value }}
                    </div>
                    <div class="font-small-2">
                      <div><b>Primary number: </b>{{ data.item.customer_phone }}</div>
                    </div>
                    <div
                      v-if="data.item.customer_secondary_phone !== null"
                      class="font-small-2"
                    >
                      <div><b>Second number: </b>{{ data.item.customer_secondary_phone }}</div>
                    </div>
                    <div class="font-small-2">
                      {{ data.item.customer_address }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(origin_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      CITY - {{ data.item.origin_city.name }}
                    </div>
                    <div class="font-small-2">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(destination_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      CITY - {{ data.item.destination_city.name }}
                      <!--                    </b-badge>-->
                    </div>
                    <div class="font-small-2">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(rider_name)="data">
                <div
                  v-if="data.item.rider"
                  class="d-flex align-items-center"
                >
                  <div>
                    <div class="font-weight-bolder">
                      {{ `${data.item.rider.first_name} ${data.item.rider.last_name || ''}` }}
                    </div>
                    <div class="font-small-2">
                      {{ data.item.rider.email }}
                    </div>
                    <div class="font-small-2">
                      {{ data.item.rider && data.item.rider.reference_id ? data.item.rider.reference_id : '' }}
                    </div>
                  </div>
                </div>
                <div v-else>
                  ---
                </div>
              </template>
              <template #cell(finance)="data">
                <div class="width-150">
                  <b>Total&nbsp;:</b>&nbsp;&nbsp;{{ __numberWithCommas(data.item.cod, true) || '---' }}
                  <div style="height:8px;" />
                  <b>Collected&nbsp;:</b>&nbsp;&nbsp;{{ data.item.collected_cod || '---' }}
                  <div style="height:8px;" />
                  <b>D-Charge&nbsp;:</b>&nbsp;&nbsp;{{ data.item.delivery_charge || '---' }}
                </div>
              </template>
              <template #cell(created_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>
              <template #cell(status.key)="data">
                <order-status-badge :status-key="data.value" />
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="12"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item
                    @click="onClickViewOrderModal(data.item.id)"
                  >
                    <feather-icon icon="EyeIcon" />
                    View
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-overlay>

          <div class="mx-2 mb-2">
            <b-row
              cols="12"
            >
              <b-col
                class="d-flex align-items-center justify-content-sm-start"
                md="3"
              >
                <label class="width-75">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block width-100"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                class="d-flex align-items-center justify-content-sm-end"
                md="9"
              >
                <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="(meta.total)? meta.total : 0"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <bulk-action-modal
      ref="bulkActionModal"
      :form_structure="formStructure"
      :status_key="status_key"
      :selected_waybill_array="selectedWaybillArray"
      :rows="rows"
      :order_settings="orderSettings"
    />
    <view-order-modal ref="viewOrderModal" />
  </div>
</template>

<script>
import {
  BAvatar,
  BRow,
  BCol,
  BTable,
  BCard,
  BButton,
  BFormGroup,
  BPagination,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  VBTooltip,
  // BTooltip,
  BFormFile,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import { avatarText } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FormBuilder from '@/libs/builders/form-builder/FormBuilder.vue'
import store from '@/store'
import BInputLabelInfo from '@/@core/components/b-input-label-info/BInputLabelInfo.vue'
import ViewOrderModal from '@/components/AllOrders/ViewOrderModal.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'
import BulkActionModal from './bulk-actions/BulkActionModal.vue'
import AutoFetch from './AutoFetch'
import BulkSubmit from './bulk-actions/BulkSubmit.vue'

const orderRepository = RepositoryFactory.get('order')
const OrderSettingsRepository = RepositoryFactory.get('orderSetting')

export default {
  name: 'KeySeven',
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    AdvancedDateFilter,
    BAvatar,
    BRow,
    BCol,
    BTable,
    BCard,
    FilterCard,
    FormBuilder,
    BButton,
    BFormGroup,
    BPagination,
    BOverlay,
    OrderStatusBadge,
    BDropdown,
    BDropdownItem,
    BulkActionModal,
    BFormCheckbox,
    ViewOrderModal,
    vSelect,
    BInputLabelInfo,
    BulkSubmit,
    // BTooltip,
    BFormFile,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, AutoFetch, tableMixin],
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    status_key: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // Table Info
      submitCount: 0,
      isDeliveryConfirmed: false,
      loadingResponse: false,
      filterAuto: true,
      avatarText,
      filters: {
        status_date: {
          startDate: null,
          endDate: null,
        },
      },
      total: 0,
      cod: 0,
      meta: {},
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      sortBy: '',
      sortDesc: false,
      dataLoading: false,
      sortDirection: 'asc',
      filterName: '',
      fields: [
        {
          key: 'id',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'waybill_number',
          label: 'WayBill Number',
          sortable: true,
        },
        {
          key: 'merchant.name',
          label: 'Merchant',
          sortable: true,
        },
        {
          key: 'customer_name',
          label: 'Customer Name',
          sortable: true,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'origin_warehouse',
          label: 'Origin',
          sortable: true,
        },
        {
          key: 'destination_warehouse',
          label: 'Destination',
          sortable: true,
        },
        {
          key: 'customer_email',
          label: 'Customer',
          sortable: true,
        },
        {
          key: 'rider_name',
          label: 'Rider',
          sortable: true,
        },
        {
          key: 'finance',
          label: 'Finance',
          sortable: false,
        },
        {
          key: 'weight',
          label: 'Net Weight',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'status.key',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
        },
      ],
      json_fields: {
        'Waybill Number': 'waybill_number',
        Merchant: {
          field: 'merchant.name',
          callback: value => `"${value}"`,
        },
        'Origin City': {
          field: 'origin_city.name',
          callback: value => `"${value}"`,
        },
        'Origin Warehouse': {
          field: 'origin_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Destination City': {
          field: 'destination_city.name',
          callback: value => `"${value}"`,
        },
        'Destination Warehouse': {
          field: 'destination_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        'Customer Address': {
          field: 'customer_address',
          callback: value => `"${value}"`, // Wrap the address in double quotes
        },
        'Customer Phone': 'customer_phone',
        'Second Phone Number': 'customer_secondary_phone',
        COD: 'cod',
        'Collected COD': 'collected_cod',
        'Delivery Charge': 'delivery_charge',
        'Net Weight': 'weight',
        Status: 'status.name',
      },
      rows: [],
      // Form Info
      formData: {
        weight: null,
        receiver_name: '',
        waybill_number: '',
        receiver_id: '',
        proof_files: [],
      },
      formStructure: [
        {
          type: 'input',
          placeholder: '',
          inputType: 'text',
          title: 'Waybill Number',
          value: 'waybill_number',
          class: 'col-8 col-md-3 d-flex',
          validation: 'required',
          searchEnable: 'displaySearchButton',
          inputClass: 'width-250',
        },
        {
          type: 'input',
          placeholder: '',
          inputType: 'number',
          title: 'Weight (Kg)',
          value: 'weight',
          class: 'col-6 col-md-2 ml-md-3',
          validation: 'required',
          ref: 'weightInput',
          events: {
            input: 'checkWeightRange',
          },
        },
        {
          type: 'input',
          placeholder: '',
          inputType: 'text',
          title: 'Receiver Name',
          value: 'receiver_name',
          class: 'col-6 col-md-3',
        },
        {
          type: 'input',
          placeholder: '',
          inputType: 'text',
          title: 'Receiver ID',
          value: 'receiver_id',
          class: 'col-6 col-md-3',
        },
      ],
      selectedWaybillArray: [],
      orderSettings: null,
      settingWaybillLength: 0,
      selectAllCheckbox: false,
      waybillSeriesList: [],
      prefixList: [],
      matchingSeries: [],
      prefixMatch: [],
      uploadedImages: [],
      uploadingCount: 0,
      max_images: 4,
      max_size_mb: 20,
      allowed_types: ['image/jpeg', 'image/png', 'image/webp'],
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    weightRange() {
      return `The order weight should be between ${this.orderSettings.weight_range_setting.min_weight} Kg to ${this.orderSettings.weight_range_setting.max_weight} Kg`
    },
    isSubmitDisabled() {
      const basicInvalid = !(this.formData.waybill_number && this.formData.weight && this.formData.receiver_name)
      return basicInvalid || this.loadingResponse || this.uploadingCount > 0
    },
  },
  watch: {
    page() {
      this.getOrderList()
    },
    perPage() {
      this.getOrderList()
    },
    loadingResponse(newValue) {
      /* eslint no-underscore-dangle: 0 */
      this.__toggleDisableInput('Waybill Number', newValue)
    },
  },
  async mounted() {
    this.totalRows = this.rows.length
    await this.readOrderSetting()
    await this.getWaybillSeriesList()
  },
  methods: {
    handleWaybillPaste(pastedText) {
      this.getOrderDetails(pastedText)
    },
    async getOrderDetails(waybill) {
      try {
        const { data } = (await orderRepository.fetchOrderData(waybill)).data
        this.formData.weight = data.weight
        this.formData.receiver_name = data.customer_name
        this.formData.cod = data.cod
      // eslint-disable-next-line no-empty
      } catch (e) {
      }
    },
    async getOrderList() {
      this.dataLoading = true
      this.rows = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await orderRepository.getOrderListByKey(this.status_key, this.page, this.perPage, filterQuery))
        this.rows = data.data
        this.meta = data.meta
        this.submitCount = 0
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async getOrderListNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await orderRepository.getOrderListByKeyNoPagination(this.status_key, filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async readOrderSetting() {
      try {
        this.orderSettings = localStorage.getItem('order_setting') ? JSON.parse(localStorage.getItem('order_setting')) : (await OrderSettingsRepository.getOrderSettingsResource()).data.data
        if (!localStorage.getItem('order_setting')) localStorage.setItem('order_setting', JSON.stringify(this.orderSettings))
        this.settingWaybillLength = this.orderSettings.waybill_setting.auto_waybill_prefix.length + Number(this.orderSettings.waybill_setting.digit_count)
        if (this.orderSettings.waybill_setting.suffix_enabled) this.settingWaybillLength += this.orderSettings.waybill_setting.auto_waybill_suffix.length
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onSubmit() {
      try {
        await this.showMsgBox()
        if (this.isDeliveryConfirmed === true) {
          this.loadingResponse = true
          const formData = new FormData()
          const waybills = this.selectedWaybillArray.length
            ? this.selectedWaybillArray
            : [this.formData.waybill_number]
          waybills.forEach((wb, i) => {
            formData.append(`waybill_numbers[${i}]`, wb)
          })
          formData.append('status_key', this.status_key)
          formData.append('other_details[weight]', this.formData.weight)
          formData.append('other_details[receiver_name]', this.formData.receiver_name)
          formData.append('other_details[receiver_id]', this.formData.receiver_id)
          this.formData.proof_files.forEach((file, index) => {
            formData.append(`proof_files[${index}]`, file)
          })

          await orderRepository.updateOrderStatus(formData)
          this.$refs.formbuilder.reset()
          this.formData.proof_files = []
          this.uploadedImages.forEach(item => item.preview && URL.revokeObjectURL(item.preview))
          this.uploadedImages = []
          // await this.getOrderList()
          this.showSuccessMessage('Order updated successfully')
          this.submitCount += 1
          this.loadingResponse = false
          this.$nextTick(() => {
            // eslint-disable-next-line no-underscore-dangle
            this.__focusInputField('Waybill Number')
          })
        }
      } catch (e) {
        this.loadingResponse = false
        this.convertAndNotifyError(e)
        this.$refs.formbuilder.reset()
        this.formData.proof_files = []
        this.uploadedImages.forEach(item => item.preview && URL.revokeObjectURL(item.preview))
        this.uploadedImages = []
        this.$nextTick(() => {
          // eslint-disable-next-line no-underscore-dangle
          this.__focusInputField('Waybill Number')
        })
      }
    },
    onClickViewOrderModal(id) {
      this.$refs.viewOrderModal.openModal(id)
    },
    onClickBulkAction() {
      this.$refs.bulkActionModal.openModal()
    },
    onClickSelectAll() {
      this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
    },
    onClickDeselctAll() {
      this.selectedWaybillArray = []
    },
    filterQueryUpdate() {
      this.getOrderList()
      this.onClickDeselctAll()
    },
    handleChangePage(page) {
      this.page = page
      this.getOrderList()
    },
    changePage(value) {
      this.perPage = value
    },
    sortChanged(e) {
      const key = e.sortBy
      if (key) {
        const active = e.sortDesc ? '-' : ''
        this.sort = active + key
        this.fetchOrderList()
      }
    },
    onClickRefresh() {
      this.getOrderList()
    },
    async showMsgBox() {
      this.isDeliveryConfirmed = false
      this.cod_display_amount = this.formData.cod
      const formattedAmount = this.cod_display_amount.toLocaleString('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      const dialogText = 'Have you collected the total COD amount ?\n'
      const collectedCODText = `Collected COD: ${formattedAmount}`
      return this.$swal({
        title: 'Confirm Delivery',
        text: dialogText + collectedCODText,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes, confirm!',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        backdrop: false,
      }).then(value => {
        this.isDeliveryConfirmed = value.isConfirmed
      })
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
      } else {
        this.selectedWaybillArray = []
      }
    },
    onSelectFiles(e) {
      const files = Array.from(e.target.files || [])
      this.handleIncomingFiles(files)
      // reset input so selecting same file again re-triggers change
      e.target.value = ''
    },
    handleIncomingFiles(files) {
      const remaining = this.max_images - this.uploadedImages.length
      if (remaining <= 0) {
        this.showErrorMessage(`You can only upload up to ${this.max_images} images.`)
        return
      }
      const take = files.slice(0, remaining)
      take.forEach(file => {
        if (!this.allowed_types.includes(file.type)) {
          this.showErrorMessage('Only jpeg, png, or webp files are allowed.')
          return
        }
        if (file.size > this.max_size_mb * 1024 * 1024) {
          this.showErrorMessage(`File too large. Max ${this.max_size_mb} MB.`)
          return
        }
        // push into proof_files to be sent on submit
        this.formData.proof_files.push(file)
        // add a preview card
        const localId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
        const preview = URL.createObjectURL(file)
        this.uploadedImages.push({
          localId,
          file,
          name: file.name,
          preview,
          status: 'ready',
          url: null,
        })
      })
    },
    removeImage(index) {
      const item = this.uploadedImages[index]
      if (item?.preview) URL.revokeObjectURL(item.preview)
      // remove from both preview list and payload list
      this.uploadedImages.splice(index, 1)
      this.formData.proof_files.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../@core/scss/vue/pages/proof-doc-upload.scss';
</style>
